import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { AssetsQueryParams, ASSETS_DEFAULT_SORT_BY, ASSETS_DEFAULT_ASC } from 'cio/models/asset';

export default class AssetsController extends Controller {
  queryParams = ['folderId', 'page', 'sort', 'asc', 'search'];

  @tracked folderId: string | null = null;
  @tracked page = 1;
  @tracked sort = ASSETS_DEFAULT_SORT_BY;
  @tracked asc = ASSETS_DEFAULT_ASC;
  @tracked search = '';

  @action
  onParamsChange(params: AssetsQueryParams) {
    let { folderId, page, sortBy, sortAsc, search } = params;

    // avoid issue where folderId is updated after being used in previous computation
    if (this.folderId !== folderId) {
      this.folderId = folderId;
    }

    this.page = page;
    this.sort = sortBy;
    this.asc = sortAsc;
    this.search = search;
  }
}
